import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import api from 'api/api';

// The backend decides (status, tenant's document type and kill switch)
export const isControlDocumentAvailable = (order) =>
  !!order?.can_download_control_document;

const useDownloadControlDocument = () => {
  const { t } = useTranslation('ShipmentCard');

  const downloadControlDocument = useCallback(
    async (orderId) => {
      // Open the tab synchronously within the click, so popup blockers allow it
      const newTab = window.open('', '_blank');
      try {
        const { data: documents } = await api.getOrderControlDocuments(orderId);
        const [first, ...rest] = documents;
        if (newTab) {
          newTab.location.href = first.url;
        } else {
          window.open(first.url, '_blank');
        }
        rest.forEach(({ url }) => window.open(url, '_blank'));
      } catch {
        newTab?.close();
        toast.error(t('deca_not_available'));
      }
    },
    [t]
  );

  return { downloadControlDocument };
};

export default useDownloadControlDocument;
